module.exports = __webpack_public_path__ + "img/accessory_shirt_09.b44f7165.svg";